export default __webpack_public_path__ + "static/media/malolos.116be00e.jpg";